/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { GroupManagementEditGroupResponse } from "./GroupManagementEditGroupResponse";

export type GroupManagementEditGroupResponseApiRespoonse = {
  data?: GroupManagementEditGroupResponse;
  status?: GroupManagementEditGroupResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace GroupManagementEditGroupResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
